import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';

import { UserService } from '../_services/user.service'
import { VaService } from '../_services/va.service'
import { LoadingSpinnerService } from '../_services/loading-spinner.service'
import { ConfirmationDialogService } from '../_services/confirmation-dialog.service';
import { NotificationService, NotificationType } from '../_services/notification.service'
import { LongProgressService } from '../_services/long-progress.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TrainingService } from '../_services/training.service';

@Component({
  selector: 'app-virtual-assistant-card',
  templateUrl: './virtual-assistant-card.component.html',
  styleUrls: ['./virtual-assistant-card.component.scss']
})
export class VirtualAssistantCardComponent implements OnInit {

  SelectedRole: any;
  SelectedUser: any = '';
  @Input() vaAgent: any;
  @Input() isSmallCard: boolean = false;
  active_va_id: any;
  public shareList: boolean = false;
  public userRoles;
  public sharedUserList;
  public params;
  public userRole = "Role";
  public tree_loader_status: boolean = true;
  public agentTitle;
  public agentDescrp;
  public agentId;
  public currentuser;
  public currentUserRole;
  public descrpChanged: boolean = false;
  public titleChanged: boolean = false;
  public titlelengthValid: boolean = true;
  public descrplengthValid: boolean = true;
  public titleFieldValid: boolean = true;
  public descrpFieldValid: boolean = true;
  public buttonStatus: boolean = false;
  public errMessage;
  public hoverActive = true;
  public deleteButtonStyle = {};
  projectShareForm: FormGroup;
  projectEditForm: FormGroup;
  tooltipPinned: any;
  activeModal;
  @Output() userPinned: EventEmitter<any> = new EventEmitter();
  @Input() packageLibrary:boolean=false;

  userList: any = [{ "username": "arjun", "avatar": "", "_id": { "$oid": "5d1ee5829d102f0026e382c9" }, "email": "arjun@cognicor.com", "name": "Arjun J" }, { "username": "nithin", "avatar": "https://ciradev.cognicor.com/user_assets/5d36deddfcbc220009c71042/binary", "_id": { "$oid": "5d22d2319d102f005280c937" }, "email": "nithin.r@cognicor.com", "name": "Nithin Cognicor" }, { "username": "rahul", "avatar": "", "_id": { "$oid": "5d1ed6cde08c2c000be5703c" }, "email": "rahul.k@cognicor.com", "name": "Rahul K" }, { "username": "sarath", "avatar": "", "_id": { "$oid": "5d1ee2ba9d102f000a55d096" }, "email": "sarath@cognicor.com", "name": "sarath kumar" }, { "username": "thamshid", "avatar": "https://ciradev.cognicor.com/user_assets/5d1dc5aa51b71b000d3bad43/binary", "_id": { "$oid": "5d1da84b8ffdff000c58a9d0" }, "email": "m.thamshid@cognicor.com", "name": "Muhammed Thamshid" }];

  constructor(private userService: UserService,
    private vaService: VaService,
    private _router: Router,
    private loadingSpinnerService: LoadingSpinnerService,
    private modalService: NgbModal,
    private _confirmationDialogService: ConfirmationDialogService,
    private _notificationService: NotificationService,
    private _longProgressService: LongProgressService,
    private formBuilder: FormBuilder,
    private _trainingService: TrainingService,
  ) { }


  mouseHover(e) {
    const deleteButtonStyle = {
      'font-size': '26px',
      'color': 'Blue',
      'background-color': 'Pink',
      'border': '1px solid Red'
    };

  }

  get DeleteButtonStyles(): any {
    return this.deleteButtonStyle;
  }


  ngOnInit() {


    // if (this.vaAgent.pinned) {
    //   this.tooltipPinned = 'Unpin Project';
    // }
    // else {
    //   this.tooltipPinned = 'Pin Project';
    // }
    // this.vaService.menuChanged.subscribe(result=>{

    //   if(result == 'instructor'){
    //     // this.isInstructor = true;
    //     // this.isViewer = true;
    //     // this.activeTab = "tab-topic";

    //      this._router.navigate(['/project/'+this.vaService.activeAgent._id.$oid+'/instructor-dashboard']);
    //     // this._vaService.menuChanged.emit(true);
    //   }
    // });
    this.projectShareForm = this.formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.email]),
      role: new FormControl('Role', Validators.required),
    });
    this.projectEditForm = this.formBuilder.group({
      title: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      decrsp: new FormControl('', [Validators.required, Validators.maxLength(120)]),
    });

  }

  setActiveVa(project) {
    
    //  this.vaService.setActiveAgent(this.active_va_id)showNotification
    //  this.userService.setConfig("active_va", this.active_va_id);
    if(!this.packageLibrary){
      if (!project.archive) {
        if (project.project_type === 'universal') {
          this._router.navigate(['/project/', project._id.$oid, 'connect-bot']);
        } else if (!project.hasOwnProperty('owl_file')) {
          this._router.navigate(['/project/', project._id.$oid, 'template-selection']);
        } else {
          this._router.navigate(['/project/', project._id.$oid, 'knowledge', 'graph']);
        }
      }
      //to remove minimizeAdvanceTestWidget when switch between projects
      this.vaService.minimizeAdvanceTestWidget.next(false)
    }
  }


  cloneProject(project) {
    this.buttonStatus = true;
    let params = {
      'title': project.title + "_copy" + new Date().getTime(),
      'description':project.description
    }

    this.vaService.cloneVA(project._id.$oid, params).subscribe((result) => {
      let progressId = this._longProgressService.showProgress("Cloning " + project["title"], "Cloning started", result["task_id"], project._id.$oid, "training", "copy");
      this._longProgressService.progressCompletedEvent.subscribe((data) => {
        let clonedAgentId
        if (data["id"] == progressId) {
          this._trainingService.checkStatus(project._id.$oid, result["task_id"]).subscribe((result) => {
            if(result['meta'] && result['meta']['cloned_agent_id']){
              clonedAgentId = result['meta']['cloned_agent_id']
            }
            this.vaService.getAgents().subscribe(
              (response: any) => {
                response.forEach(element => {
                  if(element._id.$oid == clonedAgentId){
                    element['clonedFlag']=true;
                    setTimeout(() => {
                      document.getElementById(clonedAgentId).scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
                    }, 300);
                    return
                  }
                });
                this.vaService.projectDeleteEvent.emit(project._id.$oid);
                this.buttonStatus = false;
              }, (err) => {
                console.log(err);
              })
          })
        }
      })
    },
      (error) => {
        console.log(error);
        this._notificationService.showNotification({
          message: error.error.message,
          type: NotificationType.error,
          isLoading: false
        });
        this.buttonStatus = false;
      })
  }

  downloadProject(project) {
    this.buttonStatus = true;
    this.vaService.backupVA(project._id.$oid).subscribe((result) => {
      let progressId = this._longProgressService.showProgress("Preparing for download " + project["title"], "Downloading started", result["task_id"], project._id.$oid, "training", "download");
      this._longProgressService.progressCompletedEvent.subscribe((data) => {
        if (data["id"] == progressId) {
          //console.log("end");
          this.buttonStatus = false;
        }
      })
    },
      (error) => {
        if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
          this._notificationService.showNotification({
            message: error.error.message,
            type: NotificationType.error,
            isLoading: false
          });
        }
        this.buttonStatus = false;
      });
  }

  deleteProject(project) {
    this.buttonStatus = true;
    if (project.owner == 'true' && project.shared == 'true') {
      var msg = "This project is shared with other users. Are you sure you want to trash the project  ?"
    } else if (project.owner == 'false' && project.shared == 'true') {
      var msg = "This project is shared with you. Are you sure you want to trash the project ?"
    } else {
      var msg = "Are you sure you want to trash the project ?"
    }
    this._confirmationDialogService.confirm("Trash", msg, () => {

      let notificationID = this._notificationService.showNotification({
        message: "Moving to trash",
        type: NotificationType.info,
        isLoading: true
      })
      this._notificationService.notificationID.push(notificationID);

      this.vaService.moveAgentToTrash(project._id.$oid).subscribe((result) => {
        let notifyID = this._notificationService.notificationID.shift();
        this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
        this.vaService.projectDeleteEvent.emit(project._id.$oid);
       
        this.buttonStatus = false;
      },
        (error) => {
          if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
            let notifyID = this._notificationService.notificationID.shift();
            this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
          }
          this.buttonStatus = false;
        })
    }, () => {
      this.buttonStatus = false;
    })

  }
  restoreAgentFromTrash(project) {

    this.buttonStatus = true;
    if (project.owner == 'true' && project.shared == 'true') {
      var msg = "This project is shared with other users. Are you sure you want to restore the project ?"
    } else if (project.owner == 'false' && project.shared == 'true') {
      var msg = "This project is shared with you. Are you sure you want to restore the project ?"
    } else {
      var msg = "Are you sure you want to restore the project ?"
    }
    this._confirmationDialogService.confirm("Restore", msg, () => {

      let notificationID = this._notificationService.showNotification({
        message: "Restoring",
        type: NotificationType.info,
        isLoading: true
      })
      this._notificationService.notificationID.push(notificationID);

      this.vaService.restoreAgentFromTrash(project._id.$oid).subscribe((result) => {
        let notifyID = this._notificationService.notificationID.shift();
        this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
        this.vaService.getAgents().subscribe();
        this.vaService.projectDeleteEvent.emit(project._id.$oid);
        this.buttonStatus = false;
      },
        (error) => {
          if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
            let notifyID = this._notificationService.notificationID.shift();
            this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
          }
          this.buttonStatus = false;
        })
    }, () => {
      this.buttonStatus = false;
    })

  }
  hardDeleteProject(project) {
    this.buttonStatus = true;
    if (project.owner == 'true' && project.shared == 'true') {
      var msg = "This project is shared with other users. Are you sure you want to delete the project ?"
    } else if (project.owner == 'false' && project.shared == 'true') {
      var msg = "This project is shared with you. Are you sure you want to delete the project ?"
    } else {
      var msg = "Are you sure you want to delete the project ?"
    }
    this._confirmationDialogService.confirm("Delete", msg, () => {

      let notificationID = this._notificationService.showNotification({
        message: "Deleting",
        type: NotificationType.info,
        isLoading: true
      })
      this._notificationService.notificationID.push(notificationID);

      this.vaService.deleteAgent(project._id.$oid).subscribe((result) => {
        let notifyID = this._notificationService.notificationID.shift();
        this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
        this.vaService.projectDeleteEvent.emit(project._id.$oid);
       
        this.buttonStatus = false;
      },
        (error) => {
          if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
            let notifyID = this._notificationService.notificationID.shift();
            this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
          }
          this.buttonStatus = false;
        })
    }, () => {
      this.buttonStatus = false;
    })

  }




  regenrate() {
    this.vaService.agentChangedEvent.emit(this.vaAgent._id.$oid);
  }

  showSharePannel() {
    if (this.currentUserRole == 'admin') {
      return true;
    }
    else {

      return false;

    }

  }

  openSharingModal(content) {
    this.SelectedUser = '';
    this.projectShareForm.reset();
    this.activeModal = this.modalService.open(content, { windowClass: "share-project", backdrop: "static", keyboard: false });
    
    this.vaService.getUserRole(this.vaAgent._id.$oid).subscribe((result) => {
      this.currentUserRole = result['user'].role
    })
    this.getUserRoles();
    
    this.getSharedUsers();

  }

  openEditModal(content, agent) {
    this.agentTitle = agent.title;
    this.agentDescrp = agent.description;
    this.agentId = agent._id.$oid;
    this.activeModal = this.modalService.open(content, { backdrop: "static", keyboard: false });
 
    this.descrpChanged = false;
    this.titleChanged = false;
    this.titleFieldValid = false;
    this.descrpFieldValid = false;
    this.errMessage = "";
  }

  shareProject(email, role) {

    if (this.projectShareForm.valid) {
      let notificationID = this._notificationService.showNotification({
        message: "Sharing..",
        type: NotificationType.info,
        isLoading: true
      })
      this._notificationService.notificationID.push(notificationID);

      let convertedemail = email.toLowerCase();
      this.params = {
        "email": convertedemail,
        "role": role
      }


      this.vaService.shareAgent(this.vaAgent._id.$oid, this.params).subscribe((result) => {
        this.activeModal.close()
        let notifyID = this._notificationService.notificationID.shift();
        this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
        this.SelectedRole = undefined

      },
        (error) => {
         
          /* Forbidden access */
          if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
            let notifyID = this._notificationService.notificationID.shift();
            this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
          }

        }
      )
      
    } else {
      Object.keys(this.projectShareForm.controls).forEach(field => {
        const control = this.projectShareForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });
    }



  }

  getTrimedText(text, length) {
    if (text)
    return text.substring(0, length);
  }
  getCSSClasses(agent) {
    var _class;
    switch (agent.sector) {
      case 'banking':
        _class = { 'card-banking': true }
        break;
      case 'general':
        _class = { 'card-general': true }
        break;
      case 'support':
        _class = { 'card-support': true }
        break;
      case 'insurance':
        _class = { 'card-insurance': true }
        break;
      default:
        _class = { 'card-general': true }
        break;
    }
    _class['small-card'] = this.isSmallCard
    _class['package-library-noaccess'] = this.packageLibrary
    _class['cloned-project'] = agent['clonedFlag']
    return _class
  }

  getUserRoles() {

    this.tree_loader_status = true;
    this.userService.getUserRoles().subscribe(
      result => {
     
        this.userRoles = result["roles"];
        this.tree_loader_status = false;
      }),
      (error) => {
        console.log(error);
      }
  }

  getSharedUsers() {
    this.tree_loader_status = true;
    this.vaService.listSharedUsers(this.vaAgent._id.$oid).subscribe((result) => {
      
      this.sharedUserList = result;
      this.tree_loader_status = false;
    },
      (error) => {
        console.log("error");
      })

  }

  removeUser(email) {


    var msg = "Are you sure you want to delete the user ?"

    this._confirmationDialogService.confirm("Delete", msg, () => {


      let notificationID = this._notificationService.showNotification({
        message: "Deleting",
        type: NotificationType.info,
        isLoading: true
      })
      this._notificationService.notificationID.push(notificationID);

      this.vaService.removeSharedUsers(this.vaAgent._id.$oid, email).subscribe((result) => {
        
        this.getSharedUsers();
        let notifyID = this._notificationService.notificationID.shift();
        this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
      },

        (error) => {
          console.log("error");
          if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
            let notifyID = this._notificationService.notificationID.shift();
            this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
          }
        })
    }, () => {

    });
  }

  changeUserRole(userRole, data) {

    let notificationID = this._notificationService.showNotification({
      message: "Changing",
      type: NotificationType.info,
      isLoading: true
    })
    this._notificationService.notificationID.push(notificationID);

    this.params = {
      "email": data.email,
      "role": userRole
    }

    this.vaService.updateSharedUsers(this.vaAgent._id.$oid, this.params).subscribe((result) => {
      
      let notifyID = this._notificationService.notificationID.shift();
      this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);

      /* reload sharing controls*/
      this.vaService.getUserRole(this.vaAgent._id.$oid).subscribe((result) => {
        this.currentUserRole = result['user'].role
      })

    },
      (error) => {
        console.log(error);
        if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
          this.params = error.error.status;
          let notifyID = this._notificationService.notificationID.shift();
          this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
        }

      })

  }

  saveTitle(agentTitle, agentDescrp) {
    let notificationID = this._notificationService.showNotification({
      message: "Renaming..",
      type: NotificationType.info,
      isLoading: true
    })
    this._notificationService.notificationID.push(notificationID);

    this.params = {
      "title": agentTitle,
      "description": agentDescrp
    }

    this.vaService.editAgent(this.agentId, this.params).subscribe((result) => {

      this.activeModal.close()
      let notifyID = this._notificationService.notificationID.shift();
      this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);

    },
      (error) => {

       
        /* Forbidden access */
        if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
          
          let notifyID = this._notificationService.notificationID.shift();
          this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
        }

      }
    )

    // this.vaService.editAgent(this.agentId, this.params).subscribe((result) => {
    //   this.activeModal.close()
    //   this._notificationService.changeStatus(notificationID, NotificationType.success, result['message']);
    // },
    //   (error) => {
    //     if(error.status!==403){
    //       console.log("SAVE TITLE ERRROR :",error.status,notificationID);
    //       this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
    //     }
    //   })





  }

  titleUpdate(event, length) {
    let classList = event.target.classList;
    if (classList.contains('ng-dirty')) {
      this.titleChanged = true;
    }
    if (classList.contains('ng-invalid')) {
      this.titleFieldValid = false;
    }
    if (classList.contains('ng-valid')) {
      this.titleFieldValid = true;
    }
    if (length <= 0) {
      this.titlelengthValid = false;
    }
    else {
      this.titlelengthValid = true;
    }
  }
  pinUser(project) {

    let obj: any;
    if (project.pinned) {
      obj = { 'pin': false };
    }
    else {
      obj = { 'pin': true };
    }

    this.vaService.pinProject(project._id.$oid, obj).subscribe((result: any) => {
      // let notificationID = this._notificationService.showNotification({
      //   message: result.message,
      //   type: NotificationType.success,
      //   isLoading: false
      // })

      if (result) {
        this.userPinned.emit(project);
      }
    },
      (error) => {
        if (error.status !== 403) {
          console.log(error.error.message);
          //this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
        }
      });
  }
  descrpUpdate(event, length) {
    let classList = event.target.classList;
    if (classList.contains('ng-dirty')) {
      this.descrpChanged = true;
    }
    if (classList.contains('ng-invalid')) {
      this.descrpFieldValid = false;

    }
    if (classList.contains('ng-valid')) {
      this.descrpFieldValid = true;
    }
    if (length <= 0) {
      this.descrplengthValid = false;
    }
    else {
      this.descrplengthValid = true;
    }
  }

  formValid() {
    if (this.descrpChanged || this.titleChanged) {
      if ((this.titleFieldValid || this.descrpFieldValid) && (this.titlelengthValid && this.descrplengthValid)) {
        return true;
      }
      if (!this.titlelengthValid || !this.descrplengthValid) {
        this.errMessage = "Enter valid changes in above fields";
      }
      return false;

    }
    return false;

  }

}
